//* 组件库
import { utility } from "various-ui";
//* 公共组件
import type { VisualListSequence } from "@/components/models";
//* 组件属性
import type { ModuleData, ModuleInfo } from "../index";
import { useOptions } from "./options";

export const useComposable = () => {
    //* 插件
    const route = useRoute();

    //* 配置项
    const options = useOptions();

    //* 响应式变量
    const refs = {
        //* 页面数据
        mode: ref<string>("table"),
        data: ref<ModuleInfo[]>([]),
        descript: ref<string>(""),

        //* 排序配置
        sortKey: ref<string>(""),
        sortValue: ref<string>(""),

        //* 模块状态数据
        exist: ref<boolean>(true),
        loading: ref<boolean>(true),
    };

    //* 节点
    const nodes = {
        visualList: ref<InstanceType<typeof VisualListSequence>>(),
        container: ref<HTMLElement>(),
    };

    //* 静态变量
    const variable = { render: false };

    //* 计算属性
    const computeds = {
        result: computed(() => {
            if (refs.sortKey.value && refs.sortValue.value) {
                return utility.cloneDeep(refs.data.value).sort((a: any, b: any) => {
                    if (refs.sortValue.value == "asc") return b[refs.sortKey.value] - a[refs.sortKey.value];
                    else return a[refs.sortKey.value] - b[refs.sortKey.value];
                });
            } else {
                return refs.data.value;
            }
        }),
    };

    //* 函数列表
    const methods = {
        //* 渲染函数
        render: (data: ModuleData) => {
            //* 数据初始化
            refs.data.value = data.data || [];
            refs.loading.value = false;
            refs.descript.value = data.descript;
        },

        //* 隐藏函数
        hidden: () => {
            refs.exist.value = false;
            refs.loading.value = false;
        },

        //* 模式切换
        mode: () => {
            if (refs.mode.value == "visual" && !variable.render) {
                //* 可视化模型数据获取
                refs.loading.value = true;
                api.frontend("/api/gene/sequence-visual", {
                    data: { id: route.params.id },
                    error: () => (refs.mode.value = ""),
                    success: (response) => {
                        nodes.visualList.value?.init(response, {
                            callback: () => {
                                refs.loading.value = false;
                                variable.render = true;
                            },
                        });
                    },
                });
            }
        },

        //* 排序函数
        sort: (result: { key: string; value: string }) => {
            refs.sortKey.value = result.key;
            refs.sortValue.value = result.value;
        },

        //* 跳转函数
        next: (data: any) => {
            //* 路径解析
            const { href } = routerResolve({
                name: "BioSequenceResult",
                query: { id: data.transcriptID || data.mrna_id || data.id, mode: "cDNA" },
                params: { id: route.params.id },
            });

            window.open(href as string, "_blank");
        },
    };

    return { refs, nodes, options, methods, computeds };
};
